// YNX — Meetings API client (Jitsi-powered, multi-tenant).
const API = process.env.REACT_APP_BACKEND_URL;

const wsId = () => {
  try { return localStorage.getItem('ynx_workspace_id') || ''; }
  catch (err) { console.debug('YNX meetings: localStorage blocked', err); return ''; }
};

const headers = (extra = {}) => ({
  'Content-Type': 'application/json',
  ...(wsId() ? { 'X-YNX-Workspace': wsId() } : {}),
  ...extra,
});

const json = async (res) => {
  if (!res.ok) {
    let err = `HTTP ${res.status}`;
    try { const j = await res.json(); err = j.detail || err; }
    catch (parseErr) { console.debug('YNX meetings: error body not JSON', parseErr); }
    throw new Error(err);
  }
  return res.json();
};

export const listMeetings = (status = '') => {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return fetch(`${API}/api/biz/meetings${q}`, { headers: headers() }).then(json);
};

export const getMeeting = (id) =>
  fetch(`${API}/api/biz/meetings/${id}`, { headers: headers() }).then(json);

export const createMeeting = (m) =>
  fetch(`${API}/api/biz/meetings`, {
    method: 'POST', headers: headers(), body: JSON.stringify(m),
  }).then(json);

export const updateMeeting = (id, m) =>
  fetch(`${API}/api/biz/meetings/${id}`, {
    method: 'PUT', headers: headers(), body: JSON.stringify(m),
  }).then(json);

export const deleteMeeting = (id) =>
  fetch(`${API}/api/biz/meetings/${id}`, {
    method: 'DELETE', headers: headers(),
  }).then(json);

export const markMeetingStarted = (id) =>
  fetch(`${API}/api/biz/meetings/${id}/start`, {
    method: 'POST', headers: headers(),
  }).then(json);

export const ensureMeetingIndexes = () =>
  fetch(`${API}/api/biz/meetings/_ensure_indexes`, {
    method: 'POST', headers: headers(),
  }).then(json).catch(() => null);
